import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { notification } from 'antd';

import { useAppDispatch, useAppSelector } from 'store';
import { IEventsItem } from 'store/slices/events/interfaces';
import { MainLayout } from 'components/Layout/MainLayout';
import {
  loadEventsItem,
  saveEventsItem,
  saveEventsItemAsDraft,
} from 'store/slices/events/actions';
import { LangEnum } from 'constants/lang';

import { EventsForm } from './components/EventsForm/EventsForm';
import { mapValuesToForm } from './components/formUtils';

export const AddTranslation = () => {
  const [isLoading, setIsLoading] = React.useState(false);
  const { item } = useAppSelector(state => state.events);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  React.useEffect(() => {
    dispatch(loadEventsItem(id));
  }, []);

  const onFinish = (values: IEventsItem) => {
    setIsLoading(true);
    dispatch(saveEventsItem(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/events');
      })
      .catch(() => setIsLoading(false));
  };

  const onSaveDraft = (values: IEventsItem) => {
    setIsLoading(true);
    dispatch(saveEventsItemAsDraft(values))
      .unwrap()
      .then(() => {
        notification.success({
          message: 'Cущность успешно создана',
        });
        navigate('/events');
      })
      .catch(() => setIsLoading(false));
  };

  const cancelButtonHandler = () => {
    navigate('/events');
  };

  // catalog values depends on lang
  const preparedValues = {
    ...item,
    lang: LangEnum.en,
    category: null,
    categoryData: null,
    tags: [],
    tagsData: null,
  };

  return (
    <MainLayout pageTitle='Создание'>
      {item.id && item.id === Number(id) ? (
        <EventsForm
          onFinish={onFinish}
          onSaveDraft={onSaveDraft}
          cancelButtonHandler={cancelButtonHandler}
          isDraft
          isLoading={isLoading}
          initialValues={mapValuesToForm(preparedValues)}
        />
      ) : null}
    </MainLayout>
  );
};
